import ApiClient from './ApiClient';

class InstagramLeadScoreApi extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  get(contactId) {
    return axios.get(`${this.url}/${contactId}/instagram_lead_score`);
  }

  analyze(contactId) {
    return axios.post(`${this.url}/${contactId}/instagram_lead_score/analyze`);
  }
}

export default new InstagramLeadScoreApi();
